// Tanner Fry
// dev.lasutriv@gmail.com
// Component used for creating a contact record for later review.

import { ErrorMessage, Field, Form, Formik } from 'formik';
import { ApiPostContact } from '../../../api/APIContact';

interface IContactForm {
    isContactSubmitModal: React.Dispatch<React.SetStateAction<boolean>>;
    isModelShowing: React.Dispatch<React.SetStateAction<boolean>>;
}

// The base widget that builds the entire widget via other components.
function ContactForm( {isContactSubmitModal, isModelShowing}: IContactForm ) {
    
    async function submitForm(_values: { contactName: string, contactEmail: string, contactMessage: string }, setSubmitting: { (isSubmitting: boolean): void; (arg0: boolean): void; }) {
        // Submit results to db
        // TODO: Make sure the date and time is submitted with the form
        const response = await ApiPostContact({ name: _values.contactName, email: _values.contactEmail, message: _values.contactMessage });
        console.log('Contact response: ', response);

        // Call a new generic form that is an okay button.
        isContactSubmitModal(true);
        isModelShowing(false);
        setSubmitting(false);
    }

    function resetForm() {
        isModelShowing(false);
    }

    return (
        <div className='form-container'>
            <Formik
                initialValues={ { contactName: '', contactEmail: '', contactMessage: '' } }
                validateOnMount={true}
                validateOnChange={true}
                validate={ values => {
                    const errors: Partial<{contactName: string, contactEmail: string, contactMessage: string}> = {};

                    if (!values.contactName) {
                        errors.contactName = 'Required';
                    }
                    if (!values.contactEmail) {
                        errors.contactEmail = 'Required';
                    }
                    // Email should be a valid email address
                    if (values.contactEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.contactEmail)) {
                        errors.contactEmail = 'Invalid email address';
                    }
                    if (!values.contactMessage) {
                        errors.contactMessage = 'Required';
                    }
                    // Name is min 1 character and max 50 characters
                    if (values.contactName && (values.contactName.length < 1 || values.contactName.length > 50)) {
                        errors.contactName = 'Name must be between 1 and 50 characters.';
                        if (values.contactName.length > 50) {
                            // Set the value to the max length
                            values.contactName = values.contactName.substring(0, 50);
                        }
                    }
                    if (values.contactName && !/^[a-zA-Z\s]+$/.test(values.contactName)) {
                        errors.contactName = 'Name must only contain letters and spaces.';
                        // Remove any non-letter characters
                        values.contactName = values.contactName.replace(/[^a-zA-Z\s]/g, '');
                    }
                    // Message is min 1 character and max 500 characters
                    if (values.contactMessage && (values.contactMessage.length < 1 || values.contactMessage.length > 500)) {
                        errors.contactMessage = 'Message must be between 1 and 500 characters.';
                    }
                    
                    return errors;
                }}
                onSubmit={ (values, { setSubmitting }) => {
                    submitForm(values, setSubmitting);
                    setSubmitting(false);
                }}
                onReset={ (values) => {
                    resetForm();
                }}
                enableReinitialize={true}
            >
                { ({ isSubmitting, setFieldValue, values, errors }) => (
                    <Form>
                        <div className='form-group-background-info'>
                            <div className='field-group'>
                                <div className='form-field-title'>Name<div className='required-asterisk'>*</div></div>
                                <Field name='contactName' placeholder='First name' as='input' />
                                <ErrorMessage name='contactName' component='div' className='form-error' />
                            </div>
                            <div className='field-group'>
                                <div className='form-field-title'>Email<div className='required-asterisk'>*</div></div>
                                <Field name='contactEmail' placeholder='First name' as='input' />
                                <ErrorMessage name='contactEmail' component='div' className='form-error' />
                            </div>
                            <div className='field-group'>
                                <div className='form-field-title'>Message<div className='required-asterisk'>*</div></div>
                                <Field name='contactMessage' as='textarea' rows='4'/>
                                <ErrorMessage name='contactMessage' component='div' className='form-error' />
                            </div>
                        </div>
                        <hr />
                        <div className='button-group'>
                            <button type='submit' disabled={ isSubmitting }>Submit</button>
                            <button type='reset'>Cancel</button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}


export default ContactForm;